module.exports = __webpack_public_path__ + "img/wow.cb3ad108.jpg";